import React, { useEffect, useLayoutEffect, useRef } from 'react';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default function MentionSuggestionsPortal(props) {
  const searchPortal = useRef();

  // Note: this is a workaround for an obscure issue: https://github.com/draft-js-plugins/draft-js-plugins/pull/667/files
  // Ideally we can remove this in the future.
  const searchPortalRef = (element) => {
    searchPortal.current = element;
    props.store.setReferenceElement(element);
  };

  const updatePortalClientRect = (currentProps) => {
    currentProps.store.updatePortalClientRect(currentProps.offsetKey, () =>
      searchPortal.current.getBoundingClientRect(),
    );
  };

  useIsomorphicLayoutEffect(() => {
    props.store.register(props.offsetKey);
    props.store.setIsOpened(true);
    updatePortalClientRect(props);
    // trigger a re-render so the MentionSuggestions becomes active
    props.store.setEditorState(props.store.getEditorState());
    return () => {
      props.store.unregister(props.offsetKey);
      props.store.setIsOpened(false);
      props.store.setReferenceElement(null);
    };
  }, []);

  useEffect(() => {
    updatePortalClientRect(props);
  });

  return <span ref={searchPortalRef}>{props.children}</span>;
}
